import React, { Component } from 'react';
import { Container, Row, Col, Form } from "react-bootstrap"
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import axios from 'axios';
import { formatAmount } from '../../helper';
import PageHeader from '../../Pages/admin/shared/PageHeader';
import PrintButton from '../../Pages/admin/shared/PrintButton';
import FilterCard from '../../Pages/admin/shared/FilterCard';
import Select from '../../Components/PCSelect';
import { ownLimit, limitOptions } from '../../helper/identity';

const SCREEN = '/admin/inventory-report';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        // backgroundColor: '#014a7f',
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 12,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


class InventoryReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Shop: "",
            ShopList: [],
            shopLocked: false,
            inventoryData: [],
        }
    }

    /* The Shop box lists only the user's own shop, selected and locked — every shop for an admin
     * (user, 2026-11-02). */
    async componentDidMount() {
        const limit = ownLimit('shop', SCREEN);
        let all = [];
        if (!limit) {
            try {
                const res = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetShops.php`);
                if (res.data.success === 1) all = res.data.data.map(sh => ({ value: sh.PC_SP_ID, label: sh.SP_NAME }));
            } catch (error) {
                console.error('error :>> ', error);
            }
        }
        const ShopList = limitOptions(all, limit);
        const shopLocked = !!limit && ShopList.length === 1;
        this.setState({ ShopList, shopLocked, Shop: shopLocked ? ShopList[0] : "" })
    }

    async viewReport() {
        const { Shop } = this.state;
        if (!Shop || !Shop.value) return;
        this.props.toggleLoader(true)
        let formData = {
            PC_SP_ID: Shop.value,
            PC_ITEM_STATUS: "Available"
        }
        let getAvailableInventory = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/getShopInventory.php`, formData);
        let serviceData = getAvailableInventory.data;
        let inventoryData = []
        if (serviceData.success === 1) {
            inventoryData = serviceData.data
        }
        this.setState({ inventoryData })
        this.props.toggleLoader(false)
    }

    render() {
        return (
            <Container>
                <PageHeader breadcrumb="section" title="Available Inventory"
                    right={<PrintButton content={() => this.newRef} />} />
                <FilterCard>
                    <Row style={{ alignItems: 'center' }}  >
                        <Col md={10}>
                            <Form.Group className="mb-3" >
                                <Form.Label>Shop</Form.Label>
                                <Select menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    isDisabled={this.state.shopLocked}
                                    value={this.state.Shop}
                                    options={this.state.ShopList}
                                    onChange={(v) => this.setState({ Shop: v, inventoryData: [] })}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Button className="add-button" size="small" variant="contained" onClick={this.viewReport.bind(this)} >View</Button>
                        </Col>
                    </Row>
                </FilterCard>
                <TableContainer component={Paper} className='mb-3 report-table-container' ref={el => (this.newRef = el)}  >
                    <Table className="report-table pc-shrink-table" size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow
                                className="table-rows"
                                style={{ background: "#19284a" }}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <StyledTableCell>Sr.No</StyledTableCell>
                                <StyledTableCell>Items Name</StyledTableCell>
                                <StyledTableCell>IMEI</StyledTableCell>
                                <StyledTableCell>Description</StyledTableCell>
                                <StyledTableCell>Buy Rate</StyledTableCell>
                                <StyledTableCell>Sell Rate</StyledTableCell>
                                <StyledTableCell>Status</StyledTableCell>
                                <StyledTableCell>Date</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.inventoryData.map((row, index) => (
                                <StyledTableRow key={index}>
                                    <StyledTableCell>{index + 1}</StyledTableCell>
                                    <StyledTableCell>{`${row.ItemBrand} ${row.ItemName}`}</StyledTableCell>
                                    <StyledTableCell>{row.ItemIMEI}</StyledTableCell>
                                    <StyledTableCell>{row.ItemDesc}</StyledTableCell>
                                    <StyledTableCell>{formatAmount(row.ItemRate)}</StyledTableCell>
                                    <StyledTableCell>{formatAmount(row.ItemSellRate)}</StyledTableCell>
                                    <StyledTableCell>{row.ItemStatus}</StyledTableCell>
                                    <StyledTableCell>{row.INV_DATE}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Container>
        );
    }
}

export default InventoryReport;